let globalSwipers = {
    products: {
        slider: false,
        elem: $('.js-products-slider'),
        active: false,
        query: false,
        tooltipOpen: false,
        buildForPhone: null,
        options: {
            loop: false,
            slidesPerView: 6,
            slidesPerGroup: 6,
            virtualTranslate: true,
            simulateTouch: false,
            allowTouchMove: false,
            pagination: {
                el: '.js-products-slider-dots',
                clickable: true,
                dynamicBullets: false
            },
            navigation: {
                nextEl: '.js-products-slider-next',
                prevEl: '.js-products-slider-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            breakpoints: {
                1199: {
                    loop: false,
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                    virtualTranslate: true,
                    simulateTouch: false,
                    allowTouchMove: false,
                },
                767: {
                    loop: false,
                    roundLengths: true,
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                    virtualTranslate: false,
                    simulateTouch: true,
                    allowTouchMove: true,
                    slidesOffsetBefore: 30,
                    slidesOffsetAfter: 30,
                    freeMode: true,
                    pagination: {
                        el: '.js-products-slider-dots',
                        clickable: true,
                        dynamicBullets: true,
                        dynamicMainBullets: 2
                    }
                },
                599: {
                    loop: false,
                    roundLengths: true,
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                    virtualTranslate: false,
                    simulateTouch: true,
                    allowTouchMove: true,
                    slidesOffsetBefore: 20,
                    slidesOffsetAfter: 20,
                    freeMode: true,
                    pagination: {
                        el: '.js-products-slider-dots',
                        clickable: true,
                        dynamicBullets: true,
                        dynamicMainBullets: 2
                    }
                },
                359: {
                    loop: false,
                    roundLengths: true,
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                    virtualTranslate: false,
                    simulateTouch: true,
                    allowTouchMove: true,
                    slidesOffsetBefore: 15,
                    slidesOffsetAfter: 15,
                    freeMode: true,
                    pagination: {
                        el: '.js-products-slider-dots',
                        clickable: true,
                        dynamicBullets: true,
                        dynamicMainBullets: 2
                    }
                }
            },
            on: {
                init: function () {
                    globalSwipers.products.active = true;
                    globalSwipers.products.buildForPhone = checkResolution('cxs;xs2');
                    bLazy.revalidate();

                    setTimeout(() => {
                        repositionProductSlides(globalSwipers.products);
                    }, 1);
                },
                slideChange: function () {
                    setTimeout(() => {
                        animateProductSlides(globalSwipers.products);
                    }, 1);
                },
                resize: function () {
                    repositionProductSlides(globalSwipers.products);
                }
            }
        }
    }
};

function createSwiper(slider, options = {}) {
    const defaults = {
        loop: true,
        on: {
            init: function () {
                slider.active = true;
            },
            slideChange: function () {
                bLazy.revalidate();
            }
        }
    };

    slider.slider = new Swiper(slider.elem, Object.assign(defaults, options));
}

function destroySwiper(slider) {
    slider.slider.destroy();

    slider.active = false;
}

function checkSliders(slidersGroup) {
    for (const sliderName in slidersGroup) {
        checkSlider(slidersGroup[sliderName]);
    }
}

function checkSlider(slider) {
    if (checkResolution(slider.query)) {
        if (!slider.active) {
            createSwiper(slider, slider.options);
            slider.elem.addClass('is-active');
        }
    } else {
        if (slider.active) {
            destroySwiper(slider);
            slider.elem.removeClass('is-active');
        }
    }
}

function toggleAutoplay(slider, action) {
    if (slider.active) {
        let autoplay = slider.slider.autoplay;

        if (action == 'start' && !autoplay.running) {
            autoplay.start();
        }

        if (action == 'stop' && autoplay.running) {
            autoplay.stop();
        }
    }
}
